/** 与 drawer-ui webLink 路径对齐（`home` → `/dashboard`；公开营销首页为 `/home`） */
export const ROUTES = {
  authEntry: "/auth/entry",
  /** Cold start — no Web session */
  welcome: "/welcome",
  /** Session ended or signed out */
  sessionExpired: "/session-expired",
  /** Stripe App removed from Dashboard */
  appUninstalled: "/app-uninstalled",
  /** Public marketing home (no sign-in). */
  home: "/home",
  /** Authenticated app dashboard; `/` redirects here. */
  dashboard: "/dashboard",
  pricing: "/pricing",
  docs: "/docs",
  /** @deprecated v0.7 — redirects to invoicesPdfs */
  invoices: "/invoices",
  invoicesBulkExport: "/invoices/pdfs/bulk",
  invoicesCreditNotesBulkExport: "/invoices/credit-notes/bulk",
  invoicesPdfs: "/invoices/pdfs",
  invoicesReceipts: "/invoices/receipts",
  invoicesCreditNotes: "/invoices/credit-notes",
  invoicesPayLinks: "/invoices/pay-links",
  exports: "/exports",
  exportDetail: (jobId: string) => `/exports/${jobId}` as const,
  /** v0.7 Plans & trial (wireframe /billing) */
  billing: "/billing",
  /** @deprecated v0.7 — redirects to billing */
  credits: "/credits",
  help: "/help",
  legal: "/legal",
  privacy: "/privacy",
  terms: "/terms",
} as const;

/** v0.7 sidebar + dashboard primary download pages */
export const DOWNLOAD_PAGES = [
  { route: ROUTES.invoicesBulkExport, label: "Bulk Export PDFs" },
  { route: ROUTES.invoicesPdfs, label: "Download Invoice PDFs" },
  { route: ROUTES.invoicesReceipts, label: "Download Receipts" },
  { route: ROUTES.invoicesCreditNotes, label: "Download Credit Notes" },
  { route: ROUTES.invoicesPayLinks, label: "Download Pay Links" },
] as const;

/** List download pages that use compact chrome (no footer, tighter spacing). */
export const COMPACT_DOWNLOAD_LIST_ROUTES = [
  ROUTES.invoicesPdfs,
  ROUTES.invoicesReceipts,
  ROUTES.invoicesCreditNotes,
  ROUTES.invoicesPayLinks,
] as const;

const COMPACT_DOWNLOAD_LIST_ROUTE_SET = new Set<string>(
  COMPACT_DOWNLOAD_LIST_ROUTES,
);

/** Pages that scroll inside the content area instead of the main column. */
export const INTERNAL_SCROLL_ROUTES = [
  ROUTES.exports,
  ROUTES.billing,
  ...COMPACT_DOWNLOAD_LIST_ROUTES,
] as const;

const INTERNAL_SCROLL_ROUTE_SET = new Set<string>(INTERNAL_SCROLL_ROUTES);

export function isInternalScrollRoute(pathname: string): boolean {
  return INTERNAL_SCROLL_ROUTE_SET.has(pathname);
}

export function isCompactDownloadListRoute(pathname: string): boolean {
  return COMPACT_DOWNLOAD_LIST_ROUTE_SET.has(pathname);
}
